const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the content picker component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('addProfileUsers', ['Application', 'Authorization', 'Users', 'AccessProfiles', 'Groups', '$translate', function(Application, Authorization, Users, AccessProfiles, Groups, $translate) {
  return {
    restrict: 'E',
    scope: {
      item: '=?',
      showHide: '=',
      // clearItem: '&?',
      // clearAll: '&?',
      type: '@?',
      success: '&?',
      cancel: '&?'
    },
    template: require('../../../templates/directives/access_profile/add-profile-users.html'),
    controller: ['$scope', '$window', function ($scope, $window) {
      var self = this;
      self.content = $scope.content || [];
      self.queryChanged = false;
      self.per_page = 20;
      self.endOfLine = true;
      self.selectionCount = 0;
      self.restrictions = {};
      self.creating = false;
      self.tagsVisible = true;
      self.tab = 'users'; // users | preview
      self.tabOrder = ['users', 'preview'];
      self.initialLoad = true;
      self.type = $scope.type || 'profile';
      if (self.type === 'group') {
        self.restrictions = {
          groups: '$ne,' + $scope.item
        }
      }
      if (self.type === 'group-manager') {
        self.restrictions = {
          managing_groups: '$ne,' + $scope.item
        }
      }

      self.changeTab = function(direction) {
        var add = direction === 'next' ? 1 : -1;
        var place = self.tabOrder.indexOf(self.tab);
        place = place === -1 ? 0 : place;
        if (self.tabOrder[place + add]) {
          if (self.tabOrder[place + add] === 'preview') {
            if (self.selectionCount < 1) {
              return;
            }
            self.preview.page = 1;
            self.preview.getUsers();
          }
          self.tab = self.tabOrder[place + add];
        }
      };

      self.settings = {
        non_reminder_messages: [],
        reminder_messages: [],
        due_date: 30,
        use_due: false,
        escalate_manager: false,
        escalate_buddy: false
      };

      var assignList = {
        in: {},
        nin: {},
        queries: []
      };

      var queryOptions = {
        linked_locations: 'array',
        linked_departments: 'array',
        linked_teams: 'array',
        linked_org_level: 'text',
        linked_grade: 'text',
        $or: 'textMatch',
        role: 'text',
        manager_email: 'text',
        hired: 'date',
        createdAt: 'date',
        last_login: 'date'
      };

      self.individuals = {};
      var getStandardQuery = function(){
        var q = {
          subresource: '',
          page: 1,
          per_page: self.per_page,
          fields: '_id,first_name,last_name,email,full_name,role,image,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade,job_title,last_login,createdAt,hired,manager_email,groups,managing_groups',
          'linked_locations-populate': 'name',
          'linked_departments-populate': 'name',
          'linked_teams-populate': 'name',
          'linked_org_level-populate': 'name',
          'linked_grade-populate': 'name'
        };

        if (self.type === 'group') {
          q.groups = '$ne,' + $scope.item;
        }
        if (self.type === 'group-manager') {
          q.managing_groups = '$ne,' + $scope.item;
        }

        return q;
      };

      self.query = getStandardQuery();

      self.initialize = function () {
        self.load();
      };

      self.load = function () {
        self.disableScroll = true;
        self.initialLoad = false;
        Users.find(self.query, function (users) {
          if (users.length < self.per_page) {
            self.endOfLine = true;
          }
          if (self.query.page === 1 || !self.users) {
            self.users = users;
          } else {
            self.users = self.users.concat(users);
          }
          if (!self.endOfLine) {
            self.disableScroll = false;
          }
        }, function (error) {
          console.log('Error getting users:', error);
        });
      };

      self.nextPage = function() {
        self.query.page++;
        self.load();
      };

      self.onQuery = function(opts) {
        self.initialLoad = false;
        self.endOfLine = false;
        self.query = getStandardQuery();
        if (!opts || typeof opts === 'object' && !Object.keys(opts).length) {
          self.queryChanged = false;
          self.allChecked = false;
          self.load();
          return;
        }
        self.queryChanged = true;
        self.query.page = 1;
        for (var key in opts) {
          self.query[key] = opts[key];
        }

        self.load();
      };

      self.getLocation = function(user) {
        if (user && user.linked_locations && user.linked_locations[0] && user.linked_locations[0].name) {
          return user.linked_locations[0].name;
        }
        return '-----';
      };
      self.getDepartment = function(user) {
        if (user && user.linked_departments && user.linked_departments[0] && user.linked_departments[0].name) {
          return user.linked_departments[0].name;
        }
        return '-----';
      };
      self.getTeams = function(user) {
        if (user && user.linked_teams && user.linked_teams.length) {
          var steams = '';
          user.linked_teams.forEach(function (team) {
            steams += team.name + ', ';
          });
          return steams.slice(0, -2);
        }
        return '-----';
      };
      self.getOrgLevel = function(user) {
        if (user && user.linked_org_level) {
          return user.linked_org_level.name;
        }
        return '-----';
      };
      self.getGrade = function(user) {
        if (user && user.linked_grade) {
          return user.linked_grade.name;
        }
        return '-----';
      };

      self.preview = {
        page: 1,
        per_page: 20,
        nextAllowed: false,
        show: false,
        getUsers: function() {
          var items = {};
          items.queries = assignList.queries;
          items.in = Object.keys(assignList.in);
          items.nin = Object.keys(assignList.nin);
          self.preview.show = true;

          Users.segmentationList({
            fields: '_id,first_name,last_name,email,full_name,image,job_title,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade,role,hired,createdAt,last_login',
            'linked_locations-populate': 'name',
            'linked_departments-populate': 'name',
            'linked_teams-populate': 'name',
            'linked_org_level-populate': 'name',
            'linked_grade-populate': 'name',
            page: self.preview.page,
            per_page: self.preview.per_page
          }, items).$promise
          .then(function(users) {
            self.preview.users = users;
            if (users.length < self.preview.per_page) {
              self.preview.nextAllowed = false;
              return;
            }
            self.preview.nextAllowed = true;
          });
        },
        nextPage: function() {
          self.preview.page++;
          self.preview.getUsers();
        },
        previousPage: function() {
          if (self.preview.page) {
            self.preview.page--;
            self.preview.getUsers();
          }
        }
      };

      // Functions for selecting and deselecting users to assign
      self.userClick = function(user) {
        if (self.isUserChecked(user)) {
          self.uncheckUser(user);
          return;
        }
        self.checkUser(user);
      };

      self.checkUser = function(user, id) {
        id = id ? id : user._id;
        if (assignList.nin[id]) {
          delete assignList.nin[id];
        }
        assignList.in[id] = true;
        getCount();
      };

      self.uncheckUser = function(user, id) {
        id = id ? id : user._id;
        if (assignList.in[id]) {
          delete assignList.in[id];
        }
        assignList.nin[id] = true;
        getCount();
      };

      self.selectAll = function() {
        if (self.allChecked) {
          assignList.queries.pop();
          self.allChecked = false;
          getCount();
          return;
        }

        self.allChecked = true;
        var queryAddition = {};
        if (self.query._id) {
          self.checkUser(null, self.query._id);
          return;
        }

        for (var key in queryOptions) {
          if (self.query[key]) {
            queryAddition[key] = self.query[key];
          }
        }

        if (self.restrictions) {
          for (var key in self.restrictions) {
            queryAddition[key] = self.restrictions[key];
          }
        }

        assignList.queries.push(queryAddition);
        getCount();
      };

      self.isUserChecked = function(user) {
        if (assignList.in[user._id]) {
          self.individuals[user._id] = true;
          return true;
        }
        if (assignList.nin[user._id]) {
          self.individuals[user._id] = false;
          return false;
        }
        return self.checkQueries(user);
      };

      self.checkQueries = function(user) {
        if (!assignList.queries || !assignList.queries.length) {
          self.individuals[user._id] = false;
          return false;
        }
        for (var i = 0; i < assignList.queries.length; i++) {
          var current = assignList.queries[i];
          var currentFailed = false;
          for (var key in queryOptions) {
            if (current[key]) {
              if (!self.fieldCheck(user, key, current[key])) {
                currentFailed = true;
                break;
              }
            }
          }
          if (!currentFailed) {
            self.individuals[user._id] = true;
            return true;
          }
        }
        self.individuals[user._id] = false;
        return false;
      };

      self.fieldCheck = function(user, field, option) {
        var text;
        if (!field || typeof field !== 'string') {
          return false;
        }

        switch (field) {
          case 'linked_locations':
            if (!user.linked_locations || !user.linked_locations[0] || !user.linked_locations[0]._id || option.indexOf(user.linked_locations[0]._id) === -1) {
              return false;
            }
            return true;
          case 'linked_departments':
            if (!user.linked_departments || !user.linked_departments[0] || !user.linked_departments[0]._id || option.indexOf(user.linked_departments[0]._id) === -1) {
              return false;
            }
            return true;
          case 'linked_teams':
            if(!user.linked_teams || user.linked_teams.legth === 0) {
              return false;
            }
            for(var i=0;i<user.linked_teams.length;i++) {
              if(option.indexOf(user.linked_teams[i]._id) !== -1) {
                return true;
              }
            }
            return false;
          case 'linked_org_level':
            if(!user.linked_org_level || !user.linked_org_level._id) {
              return false;
            }
            if (user.linked_org_level._id.toString() === option) {
              return true;
            }
            return false;
          case 'linked_grade':
            if(!user.linked_grade || !user.linked_grade._id) {
              return false;
            }
            if (user.linked_grade._id.toString() === option) {
              return true;
            }
            return false;
          case '$or':
            text = option.split(',')[4];
            if (user.full_name && user.full_name.indexOf(text) !== -1 || user.email && user.email.indexOf(text) !== -1 || user.job_title && user.job_title.indexOf(text) !== -1) {
              return true;
            }
            return false;
          case 'role':
            if (user.role && user.role === option) {
              return true;
            }
            return false;
          case 'hired':
            text = new Date(option.slice(10));
            if (user.hired && new Date(user.hired) > text) {
              return true;
            }
            return false;
          case 'createdAt':
            text = new Date(option.slice(10));
            if (user.createdAt && new Date(user.createdAt) > text) {
              return true;
            }
            return false;
          case 'last_login':
            text = new Date(option.slice(10));
            if (user.last_login && new Date(user.last_login) > text) {
              return true;
            }
            return false;
          default:
            return false;
        }
      };

      var getCount = function() {
        var items = {};
        items.queries = assignList.queries;
        items.in = Object.keys(assignList.in);
        items.nin = Object.keys(assignList.nin);

        Users.segmentationCount({}, items).$promise
        .then(function(count) {
          self.selectionCount = count.count ? count.count : 0;
        });
      };

      self.createAssociations = function() {
        if (self.type === 'group') {
          return self.createGroupAssociations();
        }
        if (self.type === 'group-manager') {
          return self.createGroupAssociations(true);
        }
        if (!self.type || self.type === 'profile') {
          self.createProfileAssociations();
        }
      };

      self.createProfileAssociations = function() {
        self.creating = true;
        var user = Authorization.getAuthToken().user._id;

        if (!user) {
          return;
        }

        var body = {
          users: {},
          profile: $scope.item._id,
        };


        body.users.queries = assignList.queries;
        body.users.in = Object.keys(assignList.in);
        body.users.nin = Object.keys(assignList.nin);

        AccessProfiles.queryAssign({}, body).$promise
        .then(function(results) {
          Application.messaging.addMessage({type: 'success', duration: 5, text: 'Profile updates successful!' });
          self.preview.show = false;
          self.clearChoices();
          $scope.success();
          self.creating = false;
          $scope.showHide = false;
        });
      };

      self.createGroupAssociations = function(manager) {
        self.creating = true;
        var user = Authorization.getAuthToken().user._id;

        if (!user) {
          return;
        }

        var body = {
          users: {}
        };


        body.users.queries = assignList.queries;
        body.users.in = Object.keys(assignList.in);
        body.users.nin = Object.keys(assignList.nin);
        Groups.queryAdd({subresource: $scope.item, set_managers: manager || false}, body).$promise
        .then(function(results) {
          Application.messaging.addMessage({type: 'success', duration: 5, text: 'Group updates successful!' });
          self.preview.show = false;
          self.clearChoices();
          $scope.success();
          self.creating = false;
          $scope.showHide = false;
        }).catch(function(error) {
          console.log('error: ', error);
        });
      };

      // End functions for selecting and deselecting users to assign
      self.clearChoices = function() {
        assignList = {
          in: {},
          nin: {},
          queries: []
        };
        self.individuals = {};
        self.selectionCount = 0;
        self.queryChanged = false;
        self.allChecked = false;
        self.clearQuery = true;
      };

      self.cancel = function() {
        if ($scope.cancel) {
          $scope.cancel();
          return;
        }
        $scope.showHide = false;
      };

      self.resizeWindow = function() {
        var modal = document.querySelector('.assignment--admin');
        var modalHeight = document.querySelector('.assignment--admin').clientHeight;
        var modalPadding = $window.getComputedStyle(modal).paddingBottom;
        var searchHeight = document.querySelector('.assignment--admin .usersearch').clientHeight;
        var stepbarHeight = document.querySelector('.assignment--admin .stepbar').clientHeight;
        var assignedboxHeight = document.querySelector('.assignment--admin__currentlyassigned').clientHeight;
        var newHeight = modalHeight -  (parseInt(modalPadding.replace('px','')) * 3) - searchHeight - stepbarHeight - assignedboxHeight;
        self.windowHeight = newHeight;
      };

      angular.element($window).bind('resize', function() {
        self.resizeWindow();
        $scope.$apply();
      });

      $scope.$on('$destroy', function () {
        angular.element($window).unbind('resize');
      });

      setTimeout(function() {
        // settimeout is necessary to take affect after elements have been resized
        self.resizeWindow();
        $scope.$apply();
      }, 100);

      $translate([
        'manage.assign.content_confirmMessage',
        'assignContent.search_placeholder',
        'assignContent.add_users'
      ]).then(function(translations){
        self.translations = translations;
      });

    }],
    controllerAs: 'profiles'
  };
}]);
